import { trackingAxios } from 'config/api/tracking'
import { IProviderServiceRepository } from '../domain/repositories/IProviderServiceRepository'
import { ProviderService } from '../domain/entities/ProviderService'
import { toProviderServices } from './adapters/ProviderServiceAdapter'

interface ApiProviderServiceResponse {
  id: number
  code: string
  name: string
}

interface ProviderServicesApiResponse {
  error: boolean
  data: ApiProviderServiceResponse[]
}

export class AxiosProviderServiceRepository implements IProviderServiceRepository {
  async getProviderServices(providerId: number): Promise<ProviderService[]> {
    try {
      const response = await trackingAxios.get<ProviderServicesApiResponse>(
        '/externals/providers-services',
        {
          params: {
            provider_id: providerId,
          },
        }
      )

      return toProviderServices(response.data.data)
    } catch (error) {
      console.error(
        '[AxiosProviderServiceRepository] Error fetching provider services:',
        error
      )
      throw error
    }
  }
}